import React from "react";
import DSSButton from "../../../../ui/building-blocks/atoms/dss-button";
import './footer-layout.scss';
interface PrivacyStatementModalProps {
  onClose: () => void;
  honeywellPolicy: string;
  jeppesenPolicy: string;
}
const PrivacyStatementModal = ({ onClose, honeywellPolicy, jeppesenPolicy }: PrivacyStatementModalProps) => {
  const safeHoneywellPolicy = (honeywellPolicy || '').trim() || '#';
  const safeJeppesenPolicy = (jeppesenPolicy || '').trim() || '#';

  return (
    <div className="privacy-modal-content">
      <div className="privacy-modal-title">
        Integrated Navigation Data Service by Honeywell Aerospace and Jeppesen ForeFlight Privacy Statement
      </div>
      <div className="privacy-modal-body">
        The Integrated Navigation Data Service (INDS) is jointly provided by Honeywell Aerospace and Jeppesen ForeFlight through an alliance between our companies.<br />
        Accordingly, any information that you provide when you sign up for service, while using this web site, when you contact customer support, or through other means as part of your use or our provision of the Integrated Navigation Data Service, will be shared between our two companies in support of this service. Each company will treat the information it receives in accordance with its published privacy policy.
        You can review Honeywell Aerospace's Privacy Statement  <a className="privacy-modal-link" href={safeHoneywellPolicy} target="_blank" rel="noopener noreferrer">here</a> and Jeppesen ForeFlight's Privacy Policy <a className="privacy-modal-link" href={safeJeppesenPolicy} target="_blank" rel="noopener noreferrer">here</a>.
      </div>
      <div style={{ textAlign: "right", marginTop: 24 }}>
        <DSSButton variant="secondary" onClick={onClose} id="privacy-modal-close">
          Close
        </DSSButton>
      </div>
    </div>
  );
};

export default PrivacyStatementModal;